<template>
	<v-card flat tile>
		<v-list two-line class="pb-0 pt-0">
			<v-row justify="center">
				<v-col v-if="loading" class="ma-5">
					<v-progress-linear indeterminate></v-progress-linear>
				</v-col>

				<v-col
					v-for="event in events"
					:key="event.id"
					cols="12"
					sm="6"
					style="max-width:300px"
					:order="event.order"
				>
					<app-event-card :record="event"></app-event-card>
				</v-col>

				<v-col cols="12" order="2" order-lg="3">
					<app-ad middle></app-ad>
				</v-col>
			</v-row>
		</v-list>
		<v-card-actions class="pt-0">
			<v-spacer></v-spacer>
			<v-btn color="primary" text to="/events">المزيد</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import client from "@/client";
import { addBaseURL } from "@/utils/baseURL";

export default {
	components: {
		"app-event-card": require("@/components/cards/AppEventCard").default,
		"app-ad": require("@/components/general/AppAd").default
	},
	data() {
		return {
			events: [],
			loading: true
		};
	},
	mounted() {
		this.getEvents();
	},
	methods: {
		getEvents() {
			client
				.get("/api/events/allHome")
				.then(response => {
					console.log(response);
					this.events = Object.values(response.data.data.data).map(
						(record, index) => {
							console.log(record);
							record.coverPic = addBaseURL(record.coverPic);

							record.id = record.eventID;

							record.order = index + 1;
							return record;
						}
					);

					this.loading = false;
				})
				.catch(err => {
					console.log(err);
				});
		}
	}
};
</script>